import _ from 'lodash';
import { newForumLanguages as languages } from '../constants/forum-languages';

export const MOMENT_LOCALES = {
  ..._.zipObject(languages, languages),
  tl: 'tl-ph',
  zh: 'zh-cn',
  no: 'nb',
};

const DEFAULT_DATE_FORMAT = 'MMM D';
export const DATE_FORMATS = {
  ..._.reduce(languages, (acc, value) => ({ ...acc, [value]: DEFAULT_DATE_FORMAT }), {}),
  ko: 'MMM Do',
  ja: 'MMMDo',
};



// WEBPACK FOOTER //
// ./app/constants/time.js